import React, { useState } from 'react';
import './ReportSection.css';
import VisibilityCaret from './VisibilityCaret';
import PublicationAnalysisWorkshopSection from './PublicationAnalysisWorkshopSection';

const ReportSectionActivity3 = ({ selectedWorkshop, selectedWorkshopDetails }) => {

  let wsReports = selectedWorkshopDetails?.reports || {};

  const [isHidden, setIsHidden] = useState(true);
  const toggleVisibility = () => {
    setIsHidden(!isHidden);
  };

  return (
  <section>
    <div className="hero is-primary is-bold reportSectionHeader">
      <div id="tagline" className="hero-body">
        <div className="container">
        <div className="columns">
            <div className="column is-12">
              <h1 className="title">
                Activity 3: Needs & support
                <VisibilityCaret onClick={toggleVisibility} isHidden={isHidden} />
              </h1>
            </div>
          </div>
          <div className="columns">
            {/* Left Column for Hero Text */}
            <div className="column is-half">              
              <h2 className="subtitle">
                To find key opportunities for collaboration and mutual support, the different stakeholders went into groups to identify their specific needs from other stakeholders and the resources and expertise they can contribute to the collective effort. They then discussed how BENCHMARKS can support them. The results can be used to strengthen synergies and create quality relationships for the enhancement of soil health within and beyond individual case studies.
              </h2>
            </div>            
            {/* Right Column for Icons and Subtitles */}            
            <div className="column is-half is-flex justify-content-center align-items-center">
              <div className="columns is-vcentered is-mobile">
                {/* Icons and Text */}
                <div className="column has-text-centered">
                <span className="icon is-large"><img src={process.env.PUBLIC_URL + "/icons/puzzle.svg"} alt=""></img></span>
                  <p>Identify what stakeholders need</p>
                </div>                
                <div className="column has-text-centered">
                  <span className="icon is-large"><img src={process.env.PUBLIC_URL + "/icons/hand_seedling.svg"} alt=""></img></span>
                  <p>Identify what stakeholders can contribute</p>
                </div>                
                <div className="column has-text-centered">
                  <span className="icon is-large"><img src={process.env.PUBLIC_URL + "/icons/handshake.svg"} alt=""></img></span>
                  <p>Identify how BENCHMARKS can support</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className={isHidden ? 'is-hidden' : 'block'}>
      <div className="columns">
        <div className="column">
          <div className="content text-by-image">
            <h2>Needs per stakeholder group</h2>
            <div className="content-text">
              {wsReports.text_activity_3_needs}
            </div>
          </div>
        </div>
        <div className="column">
          <div className="content text-by-image">
            <h2>Offers per stakeholder group</h2>
            <div className="content-text">
              {wsReports.text_activity_3_offers}
            </div>
          </div>
        </div>
      </div>
      <div className="columns">        
        <div className="column is-12">
          <div className="content text-by-image">
            <h2>How stakeholders want Benchmarks to support</h2>
            <div className="content-text">
              {wsReports.text_activity_3_BENCHMARKS}
            </div>
          </div>
        </div>        
      </div>
      <PublicationAnalysisWorkshopSection
        selectedWorkshop={selectedWorkshop}
        diagramKey="needs"
      />
    </div>
    <div className="block"></div>    
  </section>
  );
};

export default ReportSectionActivity3;
